import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Link } from "react-router-dom";
//UI
import { Typography, TextField, IconButton, InputAdornment, Divider } from "@mui/material";

//Infinite scroll
import InfiniteScroll from "react-infinite-scroll-component";

//Components
import Spinner from "../../../layout/Spinner";
import RecipeCard from "../../../recipes/card/RecipeCard";
import EndOfRecipes from "./EndOfRecipes";
//Actions
import { getDefaultFilters, recipeSearch, setCookbookQuery } from "../../../../actions/cookbook";

//Icons
import { ReactComponent as TitleIcon } from "../../../../assets/icons/svg/search.svg";
import { ReactComponent as SearchFiltersIcon } from "../../../../assets/icons/svg/sliders-light.svg";

//Modals
import CustomModal from "../../../modal/CustomModal";
import FiltersModal from "../modal/FiltersModal";
const SearchResults = ({
  sectionData: { recipes, loading, error, isEndOfFeed, offset },
  search: { query, preferences, filters },
  recipeSearch,
  setCookbookQuery,
  getDefaultFilters,
}) => {
  const [showFilterModal, setShowFilterModal] = useState(false);

  const toggleFilterModal = (state) => {
    setShowFilterModal(state);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    //Remove later, just fetching data for now on load to test
    if (loading && query === "") {
      getDefaultFilters();
    }
  }, []);

  const fetchMoreData = () => {
    recipeSearch(query, filters, offset);
  };

  const refreshFeed = () => {
    recipeSearch(query, filters, 0);
  };

  const handleQueryChange = (e) => {
    if (e.target.value.length > 512) {
      return;
    }

    recipeSearch(e.target.value, filters, 0);
    setCookbookQuery(e.target.value);
  };

  const getFilterCount = () => {
    return filters?.allergies.length + filters?.diets.length + filters?.include.length + filters?.exclude.length;
  };

  return (
    <div className="py-[4rem] md:py-0 md:pl-[5rem] bg-neutral-50 min-h-screen">
      <CustomModal open={showFilterModal} handleClose={() => toggleFilterModal(false)}>
        <FiltersModal handleClose={() => toggleFilterModal(false)} />
      </CustomModal>
      <div>
        <div className="p-4 md:px-8 bg-background border-b border-separator">
          <div>
            <Link to="/cookbook">
              <div className="mb-2">
                <Typography
                  variant="subtitle2"
                  className="text-secondaryText-700 font-normal"
                >{`< Go Back`}</Typography>
              </div>
            </Link>

            <div className="flex flex-row gap-4 items-center mb-4">
              <TitleIcon className="h-[1.25rem] fill-secondaryText-700" />
              <Typography variant="h6" className="font-normal leading-none">
                Search Recipes
              </Typography>
            </div>
          </div>
          <div className="w-full mt-8">
            <TextField
              fullWidth
              label="Search..."
              helperText={`${getFilterCount()} filters applied`}
              size="small"
              value={query}
              onChange={handleQueryChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => toggleFilterModal(true)}>
                      <SearchFiltersIcon className="fill-primaryText h-[1rem]" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>

        <div>
          <InfiniteScroll
            dataLength={recipes ? recipes.length : 0}
            next={fetchMoreData}
            hasMore={!isEndOfFeed}
            loader={loading && <Spinner />}
            pullDownToRefresh
            refreshFunction={refreshFeed}
            endMessage={<EndOfRecipes loading={loading} />}
            className="overflow-hidden w-full flex flex-col justify-start min-h-screen"
          >
            <div className="grid min-[500px]:gap-2 auto-fill-minmax-250 md:auto-fill-minmax-300 w-full min-[500px]:p-4 md:p-8">
              {recipes &&
                recipes.map((recipe) => (
                  <RecipeCard
                    key={recipe.id}
                    recipeid={recipe.id}
                    errorType="deleted"
                    rounded="min-[500px]:rounded-lg"
                  />
                ))}
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

SearchResults.propTypes = {
  sectionData: PropTypes.object.isRequired,
  recipeSearch: PropTypes.func.isRequired,
  setCookbookQuery: PropTypes.func.isRequired,
  search: PropTypes.object.isRequired,
  getDefaultFilters: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  sectionData: state.cookbook.results.search,
  search: state.cookbook.search,
});

export default connect(mapStateToProps, { recipeSearch, setCookbookQuery, getDefaultFilters })(SearchResults);
